

<section class="footer-content py-5">
    <div class="container">
        <div class="row">



            <div class="col-md-4">

              <div class="footer-caption text-white ">
                <h5 class="pb-3 mt-2 ">ABOUT US</h5>
                <p>Duis leo justo, condimentum at purus<br> eu,Aenean
                     sed dolor sem. Etiam massa <br>libero, auctor vitae egestas et, 
                     accumsan <br> quis nunc.Duis leo justo, condimentum <br> at purus eu,
                      posuere pretium tellus.</p>
                 <a href="#"> Read more <i class="fas fa-arrow-right fa-1x"></i></a>
              </div>      

            </div>
            <div class="col-md-4">

              <div class="footer-caption text-white ">
                <h5 class="pb-3 mt-2 ">RECENT POST</h5>
                <div class="row">

                 <div class="col-md-12">

                  <div class="media ">
                    <img src="assets/images/thumb8.png" class="mr-3 " alt="food">
                    <div class="media-body">
                      <p class="mt-0">Hand picked ingredients for our best customers </p>
                      <small class="position-relative text-muted">10 August 2020</small>
                      
                    </div>
                  </div>
                 </div>
                 <div class="col-md-12">

                  <div class="media ">
                    <img src="assets/images/thumb9.png" class="mr-3 m-photo " alt="food">
                    <div class="media-body">
                      <p class="mt-0">Hand picked ingredients for our best customers </p>
                      <small class="position-relative text-muted">10 August 2020</small>
                      
                    </div>
                  </div>
                 </div>





                </div>
              </div>      

            </div>
            <div class="col-md-4">

              <div class="footer-caption text-white ">
                <h5 class="pb-3 mt-2 ">REACH US</h5>
                <div class="i-caption pb-4">
                  <i class="fab fa-facebook-square"></i>
                  <i class="fab fa-twitter-square"></i>
                  <i class="fab fa-google"></i>
                  <i class="fab fa-youtube"></i>
                  <i class="fab fa-vimeo-square"></i>
                  <i class="fab fa-pinterest-p"></i>
                  <i class="fab fa-instagram"></i>
                </div>

                <div class="i-cont">
                  <p><i class="fas fa-map-marker-alt pr-2"></i>
                    28 Seventh Avenue, Neew York, 10014</p>
                   <p><i class="fas fa-phone-alt pr-2"></i>
                     Phone: (415) 124-5678</p>
                   <p><i class="fas fa-envelope pr-2"></i>
                     support@restaurant.com</p>
                </div>
                 
              </div>      

        </div>

        </div>
    </div>
    <div class="bg text-center py-3">
      <p> 2020.Tomato.All rights reserved. Designed with  by Taha</p>
    </div>
</section>
